"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReconciliationDescription = exports.PdfGenerateStatusStrings = exports.PaymentStatusStrings = void 0;
exports.PaymentStatusStrings = {
    NEW: 'new',
    CHECKOUT_INCOMPLETE: 'checkout_incomplete',
    CHECKOUT_AUTHORIZED: 'checkout_authorized',
    CHECKOUT_COMPLETE: 'checkout_complete',
    CHECKOUT_STARTED: 'checkout_started',
};
exports.PdfGenerateStatusStrings = {
    PENDING: 'PENDING',
};
exports.ReconciliationDescription = {
    ITEM_WAS_CANCELED: 'Item was canceled',
};
